<template>
    <div>
    </div>
</template>

<script>
 import MemberRepo from "../services/MemberRepo.js";

export default {
    name: "Dashboard",
    data() {
        return {
            isLoaded: false
        }
    },
    created() {
        MemberRepo.getMemberInfo().then(function(response) {
            if(response.data.status == 'Success') {
                this.isLoaded = true;
            }
        }.bind(this));
       
    }
}
</script>


<style lang="stylus">

</style>
